import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Observable, tap } from 'rxjs';
import { Action } from '@ngrx/store';
import { CallCentreStatusAPIActions } from '@cp/shared/data-access/+state/actions/call-centre-status.actions';
import { ComplianceSummaryAPIActions } from '@cp/shared/data-access/+state/actions/compliance-summary.actions';
import { NotificationService } from '../services/notification.service';

@Injectable()
export class NotificationsEffects {
  public populateCallCentreStatusNotifications$: Observable<Action> =
    createEffect(
      () =>
        this._actions$.pipe(
          ofType(CallCentreStatusAPIActions.loadedCallCentreStatusSuccessfully),
          tap(({ callCentreStatus }) => {
            this._notificationService.populateNotificationForCallCentreStatus(
              callCentreStatus,
            );
          }),
        ),
      { dispatch: false },
    );

  public populateComplianceStatusNotifications$: Observable<Action> =
    createEffect(
      () =>
        this._actions$.pipe(
          ofType(
            ComplianceSummaryAPIActions.loadedComplianceSummarySuccessfully,
          ),
          tap(({ complianceSummary }) => {
            this._notificationService.populateNotificationsForComplianceStatus(
              complianceSummary,
            );
          }),
        ),
      { dispatch: false },
    );

  // todo: banner was removed from TNSDS-6106 and removed from MVP
  // public populateTrainingNotifications$: Observable<Action> = createEffect(
  //   () =>
  //     this._actions$.pipe(
  //       ofType(TrainingSummaryAPIActions.loadTrainingSummarySuccess),
  //       tap(() => this._notificationService.populateNotificationForTraining())
  //     ),
  //   { dispatch: false }
  // );

  constructor(
    private _actions$: Actions,
    private _notificationService: NotificationService,
  ) {}
}
